import { PopoverContent } from "@/components/molecules/popover";
import { DirectiveBuilderStepPanels } from "../../directives/builder/panels/stepPanels";
import { getChipDirectiveBuilderStepPanelProps } from "../../directives/builder/panels/chipStepPanelModel";
import type { DirectiveChipPopoverContentProps } from "../../types/directiveChipTypes";

export const DirectiveChipPopoverContent = (
  props: DirectiveChipPopoverContentProps,
) => {
  const panelProps = getChipDirectiveBuilderStepPanelProps(props);

  return (
    <PopoverContent
      dropdownPanel
      className="w-auto max-w-[320px] p-2"
      align="start"
      sideOffset={4}
      onOpenAutoFocus={props.onOpenAutoFocus}
      onCloseAutoFocus={props.onCloseAutoFocus}
      onInteractOutside={(e) => {
        if (props.preventCloseOnceRef.current) {
          e.preventDefault();
          props.preventCloseOnceRef.current = false;
        }
      }}
    >
      {panelProps == null ? (
        <p className="text-sm text-foreground/45">
          Click a segment to edit directive, variable, or choice.
        </p>
      ) : (
        <DirectiveBuilderStepPanels {...panelProps} />
      )}
    </PopoverContent>
  );
};
